export interface GlobalAudienceUiStateParams {
  // hasMarkets && the GlobalAudience feature flag. When false, the whole
  // global-audience UI is inert — this is what keeps ad-hoc / single-market and
  // flag-off projects unchanged.
  globalAudienceEnabled: boolean
  // The member's isGlobal flag.
  isGlobal: boolean
  // Whether the CURRENT market is the base market.
  isBaseMarket: boolean
  // Whether the base-market lookup is still resolving.
  baseMarketLoading: boolean
}

export interface GlobalAudienceUiState {
  // Lock wording/options of a global question in a non-base market.
  isGlobalReadOnly: boolean
  // Show the "Global" toggle (interactive in the base market, indicator elsewhere).
  showGlobalToggle: boolean
  // Toggle is a disabled indicator when a base market owns the question.
  isGlobalToggleDisabled: boolean
}

/**
 * Pure derivation of the global-audience UI state for a custom audience card.
 * Extracted so the gating — especially the guarantee that everything is off for
 * ad-hoc / single-market and flag-off projects — is unit-testable without
 * mounting the card. Read-only keys only on the CURRENT market's own isBase
 * (see useIsBaseMarket); nothing here depends on other markets.
 */
export const globalAudienceUiState = ({
  globalAudienceEnabled,
  isGlobal,
  isBaseMarket,
  baseMarketLoading
}: GlobalAudienceUiStateParams): GlobalAudienceUiState => ({
  isGlobalReadOnly: globalAudienceEnabled && isGlobal && !isBaseMarket,
  showGlobalToggle:
    globalAudienceEnabled && !baseMarketLoading && (isBaseMarket || isGlobal),
  isGlobalToggleDisabled: !isBaseMarket
})
